// extracted by mini-css-extract-plugin
module.exports = {"pic":"EmptyProfile_pic__3IIub","comment":"EmptyProfile_comment__2bSFt"};